import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { App, Alert, Button, Flex, Typography, } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { SparkleIcon } from 'components/CustomIcons';
import { renderMarkdown } from 'libs/markdown';
import { txt } from 'libs/i18n';
import styles from './style.module.less';
const { Text } = Typography;
const ResultContent = ({ aiResult, willCreateProject, willStreamToProject, isMultipleProjects, }) => {
    const { message } = App.useApp();
    const handleCopy = async () => {
        if (aiResult.status === 'success' && 'text' in aiResult.result) {
            await navigator.clipboard.writeText(aiResult.result.text);
            void message.success(txt('textCopied'));
        }
    };
    if (aiResult.status === 'loading') {
        return (_jsxs("div", { className: styles.loading, children: [_jsx(SparkleIcon, { className: styles.loadingIcon }), _jsx("div", { className: styles.loadingText, children: txt('generating') })] }));
    }
    if (aiResult.status === 'error') {
        return _jsx(Alert, { message: `${txt('aiError')}: ${aiResult.message}`, type: "error", showIcon: true });
    }
    if (willStreamToProject && aiResult.status !== 'success') {
        return (_jsx(Alert, { message: txt('translationWillBeStreamedToProject'), type: "info", showIcon: true }));
    }
    if (willCreateProject && aiResult.status !== 'success') {
        return (_jsx(Alert, { message: txt(isMultipleProjects ? 'projectWillBeCreatedWithoutRecording' : 'projectWillBeCreated'), type: "info", showIcon: true }));
    }
    if (aiResult.status === 'empty') {
        return (_jsx(Text, { className: styles.textArea, id: "generated-text-ai-modal", children: _jsx("span", { className: styles.placeholder, children: txt('emptyAiPlaceholder') }) }));
    }
    if ('text' in aiResult.result) {
        return (_jsxs(_Fragment, { children: [_jsx(Text, { className: styles.textArea, id: "generated-text-ai-modal", children: _jsx("span", { dangerouslySetInnerHTML: { __html: renderMarkdown(aiResult.result.text) } }) }), _jsx(Flex, { justify: "end", className: styles.copyButton, children: _jsx(Button, { onClick: handleCopy, icon: _jsx(CopyOutlined, {}), children: txt('copyLabel') }) })] }));
    }
    return (_jsx(Flex, { vertical: true, children: _jsx("a", { href: aiResult.result.location, target: "_blank", rel: "noopener noreferrer", children: txt('openProject') }) }));
};
export default ResultContent;
